export const SLOT_KEYS = {
  LEFT_TOP: 'left-top',
  LEFT_MIDDLE: 'left-middle',
  LEFT_BOTTOM: 'left-bottom',
  RIGHT_TOP: 'right-top',
  RIGHT_MIDDLE: 'right-middle',
  RIGHT_BOTTOM: 'right-bottom',
  CENTER_FLOAT: 'center-float'
}

export const METER_PREFIX = 'meter-'

export const CHART_SLOTS = [
  { key: SLOT_KEYS.LEFT_TOP, side: 'left', class: 'top' },
  { key: SLOT_KEYS.LEFT_MIDDLE, side: 'left', class: 'middle' },
  { key: SLOT_KEYS.LEFT_BOTTOM, side: 'left', class: 'bottom' },
  { key: SLOT_KEYS.RIGHT_TOP, side: 'right', class: 'top' },
  { key: SLOT_KEYS.RIGHT_MIDDLE, side: 'right', class: 'middle' },
  { key: SLOT_KEYS.RIGHT_BOTTOM, side: 'right', class: 'bottom' }
]

export const LIVE_MESSAGE_KPI_IDS = [1006, 1016, 1007]

export function meterSlotKey(index) {
  return `${METER_PREFIX}${index}`
}

export function createDefaultLayout() {
  return {
    mapIds: [],
    mapAreaOpacity: 50,
    slots: {
      [SLOT_KEYS.LEFT_TOP]: { kpiId: 1001, name: '', param: null },
      [SLOT_KEYS.LEFT_MIDDLE]: { kpiId: 1002, name: '', param: null },
      [SLOT_KEYS.LEFT_BOTTOM]: { kpiId: 1006, name: '', param: null },
      [SLOT_KEYS.RIGHT_TOP]: { kpiId: 1003, name: '', param: null },
      [SLOT_KEYS.RIGHT_MIDDLE]: { kpiId: 1004, name: '', param: null },
      [SLOT_KEYS.RIGHT_BOTTOM]: { kpiId: 1016, name: '', param: null },
      [SLOT_KEYS.CENTER_FLOAT]: { kpiId: 1005, name: '', param: null }
    },
    meters: [
      { kpiId: 1008, name: '', param: null },
      { kpiId: 1009, name: '', param: null },
      { kpiId: 1010, name: '', param: null },
      { kpiId: 1011, name: '', param: null },
      { kpiId: 1012, name: '', param: null },
      { kpiId: 1013, name: '', param: null }
    ]
  }
}

export function getChartSlot(layout, slotKey) {
  return layout.slots[slotKey]
}

export function collectKpiItems(layout) {
  const items = CHART_SLOTS.map(({ key }) => {
    const slot = layout.slots[key]
    return { slotKey: key, kpiId: slot.kpiId, param: slot.param }
  })
  items.push({
    slotKey: SLOT_KEYS.CENTER_FLOAT,
    kpiId: layout.slots[SLOT_KEYS.CENTER_FLOAT].kpiId,
    param: layout.slots[SLOT_KEYS.CENTER_FLOAT].param
  })
  layout.meters.forEach((meter, index) => {
    items.push({ slotKey: meterSlotKey(index), kpiId: meter.kpiId, param: meter.param })
  })
  return items
}

export function iterateChartSlots(layout, fn) {
  CHART_SLOTS.forEach(({ key }) => fn(key, layout.slots[key]))
}
